import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import { ReviewAnalysisDateRange } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

export const useGetReviewAnalysisPlatformActivityQuery = (
  campaignId: string,
  platformId: string,
  range?: ReviewAnalysisDateRange,
  enabled = true,
  facilityIds: string[] = []
) =>
  useQuery({
    enabled: enabled && !!campaignId && !!platformId,
    queryFn: () =>
      ReviewAnalysisApiService.getPlatformActivity(
        campaignId,
        platformId,
        range,
        facilityIds
      ),
    queryKey: [
      QueryKey.GET_REVIEW_ANALYSIS_PLATFORM_ACTIVITY,
      campaignId,
      platformId,
      range?.from ?? '',
      range?.to ?? '',
      facilityIds.join(','),
    ],
  })
